import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface MyProps {
    children: any;
    text: string;
    title: string;
    onClick: Function;
}

const AreYouSure: React.FunctionComponent<MyProps> = props => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const closeCancel = () => {
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const closeConfirm = () => {
        setOpen(false);
        props.onClick();
    };

    const childrenWithProps = React.Children.map(props.children, child =>
        React.cloneElement(child, { onClick: handleClickOpen })
    );

    return (
        <div>
            {childrenWithProps}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={closeConfirm} color="primary" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export { AreYouSure };
